import React, { Component } from "react";
import {
  profile,
  GET,
  PUT,
  alert,
  loading,
  tokens,
  Modal,
  required,
  float,
} from "./CustomComponent.js";
import { Navbar, Nav } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import LOGO from "../assets/images/logo192.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount = async () => {};

  icon = (io) => <span className="icon">{io}</span>;

  render() {
    const {} = this.state;
    return (
      <div>
        <div className="w-100 position-fixed" style={{ zIndex: 1000 }}>
          <div className="w-100 bg-orange px-3 py-1 d-flex justify-content-between">
            <div className=" d-flex align-items-center">
              <div className="wpx-30 hpx-30 me-2">
                           <img alt="Logo" src={LOGO} width={30}/>
                          </div>
              <h5 className="fw-bold mb-0">ZENITH CARGO</h5>
            </div>
            <div className="d-flex">
              <div className="py-2 mt-1 d-none d-md-block">
                <a className="btn-custom mx-1" href="#index">
                  หน้าแรก
                </a>
              </div>
              {/* <div className="py-2 mt-1 d-none d-md-block">
                <a className="btn-custom mx-1" href="#rate">
                  อัตราค่าบริการ
                </a>
              </div> */}
              <div className="py-2 mt-1 d-none d-md-block">
                <a className="btn-custom mx-1" href="#contact">
                  ติดต่อเรา
                </a>
              </div>
              <div className="py-2">
                <a className="btn btn-light mx-1" href="/login">
                  ลงชื่อเข้าใช้/สมัคร
                </a>
              </div>
            </div>
          </div>
          <div className="hpx-60" />
        </div>
      </div>
    );
  }
}
